module.exports = __webpack_public_path__ + "static/media/Checkpoint®_stacked_72ppi.16bdbc4a.png";